module.exports = __webpack_public_path__ + "img/Slide42.7acc3399.png";